import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "survey",
  initialState: {
    update: false,
    surveyData: null,
    userResponses: null,
    maxPage: 0,
    errors: {},
    errorAPI: "",
    loading: true,
    kioski: false,
    actionResponse: null,
  },
  reducers: {
    setSurveyData(state, { payload }) {
      state.surveyData = payload;
    },
    setUserReponses(state, { payload }) {
      state.userResponses = payload;
    },
    setErrorAPI(state, { payload }) {
      state.errorAPI = payload;
    },
    setUpdate(state) {
      state.update = !state.update;
    },
    setMaxPage(state, { payload }) {
      return { ...state, maxPage: payload };
    },
    setResponseQuestion(state, { payload }) {
      state.errors = {};
      const { optionSelected, questionPosition } = payload;
      state.surveyData.pages[state.currentPage].questions[
        questionPosition
      ].response = optionSelected;
    },
    setErrors(state, { payload }) {
      state.errors = payload;
    },
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    setKioskiMode(state, { payload }) {
      state.kioski = payload;
    },
    setActionResponse(state, { payload }) {
      state.actionResponse = payload;
    },
  },
});

export const {
  setSurveyData,
  setMaxPage,
  setResponseQuestion,
  setUserReponses,
  setUpdate,
  setErrorAPI,
  setErrors,
  setLoading,
  setKioskiMode,
  setActionResponse,
} = slice.actions;

export const surveyData = (state) => state.survey.surveyData;
export const maxPage = (state) => state.survey.maxPage;
export const errors = (state) => state.survey.errors;
export const userResponses = (state) => state.survey.userResponses;
export const update = (state) => state.survey.update;
export const errorAPI = (state) => state.survey.errorAPI;
export const loading = (state) => state.survey.loading;
export const kioski = (state) => state.survey.kioski;
export const actionResponse = (state) => state.survey.actionResponse;

export default slice.reducer;
